import { isCDA } from '.';
import { isCMG } from './ally-bank';
import { isInvest, isWealthAccount, isManagedPortfolio } from './invest';
export function getAccountId(account) {
    if (!isInvest(account))
        return account.domainDetails.accountId;
    return account.accountNumberPvtEncrypt;
}
export function getBalance(account) {
    if (isCMG(account))
        return account.domainDetails.helocAvailableBalancePvtEncrypt || 0;
    if (isManagedPortfolio(account) || isWealthAccount(account) || isCDA(account))
        return account.currentBalance || 0;
    return account.availableBalance || 0;
}
//# sourceMappingURL=shared.js.map